import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useConfig } from '../../hooks';
import { useStores } from '../../stores';
import IconButton from '../IconButton';
import MinimizeIcon from '../Icons/Minimize';
import { ControlsItem } from './Controls';

const MinimizeButton = (props, ref) => {
  const { chatWindow } = useStores();
  const {
    header: {
      title: { color, iconColor }
    }
  } = useConfig();
  const { i18n, t } = useTranslation();

  return (
    <ControlsItem ref={ref} {...props}>
      <IconButton
        onClick={() => chatWindow.minimize()}
        title={i18n.exists('altText.minimise') ? t('altText.minimise') : ''}
      >
        <MinimizeIcon fill={iconColor || color} />
      </IconButton>
    </ControlsItem>
  );
};

export default observer(MinimizeButton, { forwardRef: true });
